import React from "react";

import VideoPlayer from "./video-player";

type Props = {
  videos: Videos;
  isLoading: boolean;
};

const VideosList: React.FC<Props> = props => {
  const videos = props.videos || [];

  return (
    <div className="flex flex-col space-y-5">
      <div className="flex-shrink-0 w-px"></div>

      {props.isLoading &&
        Array.from(Array(5).keys()).map(id => (
          <div className="" key={id}>
            <div className="w-full h-48 pb-1 bg-gray-300 rounded-xl animate-pulse aspect-w-16 aspect-h-9">
              <div className="flex flex-col justify-end h-full px-4 py-2">
                <div className="flex items-center">
                  <button className="flex-shrink-0 w-10 h-10 mr-3 bg-gray-400 rounded-full animate-pulse" />

                  <div className="flex-1">
                    <p className="h-3 pr-4 bg-gray-400 rounded-lg animate-pulse" />
                    <p className="h-2 mt-2 bg-gray-400 rounded-lg animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

      {videos.map(video => (
        <div className="" key={video.id}>
          <VideoPlayer video={video} />
        </div>
      ))}

      <div className="flex-shrink-0 w-px"></div>
    </div>
  );
};

export default VideosList;
